export default "__VITE_ASSET__DgcbrVL8__"